module.exports = __webpack_public_path__ + "img/image-simple-steps-banner.61f079ac.svg";